import { render, staticRenderFns } from "./NewPlayerPausing.vue?vue&type=template&id=375f34bd"
import script from "./NewPlayerPausing.vue?vue&type=script&lang=js"
export * from "./NewPlayerPausing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports